<template>
  <div class="container">
    <van-nav-bar>
      <template #title>
        <span style="font-size: 1rem; color: #fff;">{{ $t('message.title') }}</span>
      </template>
    </van-nav-bar>
    
    <div class="wrap" id="content">


      <van-pull-refresh v-model="isLoading" @refresh="refresher" class="container" :pulling-text="$t('common.pullLabel1')" :loosing-text="$t('common.pullLabel2')" :loading-text="$t('common.pullLabel3')">
        <Nodata v-if="liushuiList.length === 0" />
        <van-list v-model="loading" :finished="finished" :finished-text="$t('common.nomore')" :loading-text="$t('common.loading')" :error-text="$t('common.error')" @load="onLoad">
          <div class="wrap">
            <div class="card" v-for="(item,index) in liushuiList" :key="index"  @click="goPage(item)">
              <div class="left">
                <div class="title">{{ item.title }}</div>
                <div class="time">{{ item.content }}</div>
              </div>
              <div class="status">{{ item.author }}</div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>


    </div>
  </div>
</template>

<script>
import message from './message.json'
import Nodata from "@/common/Nodata.vue";
export default {
  components: { Nodata },
  data() {
    return {
      liushuiList:[],
      page:0,
      finished: false,
      loading: false,
      isLoading: false
    };
  },
  created() {
    console.log(message)
    // this.liushuiList = message.data
    // this.getLiushuiList()
  },
  methods: {
    goPage(e) {
      localStorage.setItem('messageDetail', JSON.stringify(e))
      this.$router.push(`/MessageDetail`)
    },
    
    async getLiushuiList(refresh=true){
      return this.$http({
        method: 'get',
        data:{id:this.type,page:this.page},
        url: 'message_list'
      }).then(res=>{
        this.total = res.data.total;
        if(refresh) {
          this.liushuiList = res.data.data
        }else {
          this.liushuiList = [...this.liushuiList, ...res.data.data]
        }
        this.loading = false
        if(this.liushuiList.length >= this.total) {
          this.finished = true
        }
      })
    },

    onLoad() {
      console.log('onload')
      this.page ++
      this.getLiushuiList(false);
    },
    
    async refresher() {
      this.isLoading = true
      this.page = 1
      await this.getLiushuiList()
      this.finished = false
      this.isLoading = false
    },
  }
};
</script>

<style lang='less' scoped>
.van-nav-bar {
  height: 2.88rem;
}

::v-deep .van-tabs {
  .van-tab, .van-tabs__wrap {
    height: 2.75rem;
  }
  .van-tab__text{
    font-size: 0.88rem;
    line-height: 2.75rem;
    color: #6f41b9;
  }
  .van-tab--active .van-tab__text{
    font-weight: bold;
  }
}

.container{
  height: 100%;
  background: linear-gradient(180deg, #fff5f8 0%, #f8f3ff 55%, #fff6f0 100%);
}

.wrap{
  .container {
    height: calc(var(--vh) * 100 - 2.88rem);
    overflow-y: auto;
  }
    .card{
    width: 92%;
    height: auto;
    min-height: 4.13rem;
    margin: 0.55rem auto 0;
    padding: 0.75rem 0.9rem;
    border-radius: 1.1rem;
    background: #fff;
    box-shadow: 0 0.3rem 0.9rem rgba(183, 156, 236, 0.14);
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    .left{
      width: 68%;
    }
    .title {
      font-size: 0.92rem;
      color: #4a3a5c;
      font-weight: 700;
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .time{
      font-size: 0.75rem;
      color: #a99cba;
      margin-top: 0.25rem;
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .status {
      background: linear-gradient(120deg, #f7a1c0, #c3a3f2);
      color: #fff;
      font-size: 0.69rem;
      padding: 0.2rem 0.5rem;
      border-radius: 1rem;
      height: auto;
      line-height: 1.3;
      max-width: 28%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

::v-deep .van-list__finished-text{
  font-size: 1.00rem !important;
  height: 3.13rem;
  line-height: 3.13rem;
}
::v-deep .van-loading__text {
  font-size: 1.00rem !important;
}

</style>
